import { env } from '../../config/env.js';

/**
 * @returns {Record<string, string>}
 */
export function getAuthHeaders() {
  const headers = {
    'UTC-Offset': String(new Date().getTimezoneOffset()),
    AppVersion: env.appVersion,
  };

  const token = localStorage.getItem('accounts:accessToken');
  if (token) {
    headers['accounts-access-token'] = token;
  }

  return headers;
}

/**
 * @returns {Record<string, string>}
 */
export function getConnectionParams() {
  const params = {
    'UTC-Offset': String(new Date().getTimezoneOffset()),
    AppVersion: env.appVersion,
  };

  const token = localStorage.getItem('accounts:accessToken');
  if (token) {
    params['accounts-access-token'] = token;
  }

  return params;
}
